import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GetExtensionDetail_extension_extensionMailbox } from '../../queries/generated/GetExtensionDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-extension-mail-box-detail-left-column',
    styleUrls: ['./extension-mail-box-detail-left-column.component.scss', '../extension-detail-view.component.scss'],
    templateUrl: './extension-mail-box-detail-left-column.component.html',
    standalone: false
})
export class ExtensionMailboxDetailLeftColumnComponent {
   @Input() extensionMailbox: GetExtensionDetail_extension_extensionMailbox | null;

   @Input() timeZoneId: string | null;
}
